import React from 'react';
import CodeBlock from '../components/CodeBlock';

const Groups = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1>👥 Groups</h1>
        <p>Gérer les groupes (segments) de contacts. Idéal pour déclencher des flows quand un contact est ajouté à un groupe spécifique.</p>
      </div>

      <div className="section">
        <h2>Lister / Créer / Supprimer</h2>

        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-get">GET</span>
            <span className="endpoint-path">/api/v1/groups</span>
          </div>
          <CodeBlock language="bash" code={`curl https://api.whakup.com/api/v1/groups \\
  -H "Authorization: Bearer YOUR_JWT" \\
  -H "X-Workspace-Id: 42"`} />
        </div>

        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-post">POST</span>
            <span className="endpoint-path">/api/v1/groups</span>
          </div>
          <h4>Body</h4>
          <CodeBlock language="json" code={`{ "title": "Clients VIP" }`} />
          <h4>Réponse 201</h4>
          <CodeBlock language="json" code={`{
  "data": {
    "id": 5,
    "title": "Clients VIP",
    "createdAt": "2026-05-04T14:30:00+00:00"
  }
}`} />
          <p>Si un groupe avec ce titre existe déjà : HTTP 409 avec l'<code>id</code> existant.</p>
        </div>

        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-delete">DELETE</span>
            <span className="endpoint-path">/api/v1/groups/{'{id}'}</span>
          </div>
        </div>
      </div>

      <div className="section">
        <h2>Ajouter / retirer un contact</h2>
        <p>
          Particulièrement utile pour déclencher des flows : quand un contact est ajouté à un groupe,
          tous les flows configurés sur le trigger <code>group_added</code> de ce groupe se déclenchent.
        </p>

        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-post">POST</span>
            <span className="endpoint-path">/api/v1/groups/{'{id}'}/contacts</span>
          </div>
          <h4>Body</h4>
          <CodeBlock language="json" code={`{ "contactId": 1234 }`} />
        </div>

        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-delete">DELETE</span>
            <span className="endpoint-path">/api/v1/groups/{'{id}'}/contacts/{'{contactId}'}</span>
          </div>
        </div>
      </div>

      <div className="section">
        <h2>Scope requis</h2>
        <ul>
          <li><code>groups:read</code> pour les <code>GET</code></li>
          <li><code>groups:write</code> pour les écritures et l'ajout/retrait de contacts</li>
        </ul>
      </div>
    </div>
  );
};

export default Groups;
